import axios from 'axios';

const RESOURCE = '/api/languages';

export interface LanguageInfo {
  name: string;
  localName: string;
}

export default {
  /**
   * Get all available languages
   */
  async getLanguages(): Promise<{ languages: Record<string, LanguageInfo> }> {
    try {
      const response = await axios.get<{ languages: Record<string, LanguageInfo> }>(`${RESOURCE}`);
      const languages: Record<string, LanguageInfo> = {};
      if (response.data?.languages) {
        Object.entries(response.data?.languages).forEach(([code, info]) => {
          if (info) {
            languages[code] = {
              name: info.name || code,
              localName: info.localName || info.name || code
            };
          }
        });
      }
      return { languages };
    } catch (error) {
      console.error('Failed to fetch languages:', error);
      return {
        languages: { en: { name: 'English', localName: 'English' } }
      };
    }
  },
}; 